module.exports = __webpack_public_path__ + "media/images/icon-arrow-ur-97fae73b353dbd8489c16691b388dfb7.png";